import React from "react";
import { useTranslation } from "react-i18next";

const Services = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="services__one section-padding" id="services">
      <div className="shape-slide">
        <div className="sliders scroll">
          <img src="/img/shape/services-1.png" alt="service-shape" />
        </div>
        <div className="sliders scroll">
          <img src="/img/shape/services-1.png" alt="service-shape" />
        </div>
      </div>
      <div className="container">
        <div className="row mb-30 align-items-end">
          <div className="col-xl-9 col-lg-9 lg-mb-30">
            <div className="services__one-title lg-t-center">
              <h2>{t("our_plan")}</h2>
            </div>
          </div>
        </div>
        {data && <div dangerouslySetInnerHTML={{ __html: data }}></div>}
      </div>
    </div>
  );
};

export default Services;